import { wrapInput } from '@danderson00/react-forms'
import { Body, Box, Checkbox as CheckboxWidget } from '../widgets'

export const Checkbox = wrapInput(
  ({ name, checked, onChange, title, dark, error }) => (
    <Box gap={8} alignItems="center">
      <CheckboxWidget name={name} checked={checked} onChange={onChange} dark={dark} error={error} />
      <Body lineHeight={1.7}>{title}</Body>
    </Box>
  ),
  {
    type: 'checkbox',
    valueFromEvent: x => x
  }
)